import { render, staticRenderFns } from "./academic.vue?vue&type=template&id=3900c203&scoped=true"
import script from "./academic.vue?vue&type=script&lang=js"
export * from "./academic.vue?vue&type=script&lang=js"
import style0 from "./academic.vue?vue&type=style&index=0&id=3900c203&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3900c203",
  null
  
)

export default component.exports